// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"styles_tableWrap__11t6w"};